export const REGISTER_LOGIN_REQUEST = "REGISTER_LOGIN_REQUEST";
export const REGISTER_LOGIN_SUCCESS = "REGISTER_LOGIN_SUCCESS";
export const REGISTER_LOGIN_FAIL = "REGISTER_LOGIN_FAIL";
export const REGISTER_LOGOUT = "REGISTER_LOGOUT";

export const REGISTER_REGISTER_REQUEST = "REGISTER_REGISTER_REQUEST";
export const REGISTER_REGISTER_SUCCESS = "REGISTER_REGISTER_SUCCESS";
export const REGISTER_REGISTER_FAIL = "REGISTER_REGISTER_FAIL";

export const REGISTER_DETAILS_REQUEST = "REGISTER_DETAILS_REQUEST";
export const REGISTER_DETAILS_SUCCESS = "REGISTER_DETAILS_SUCCESS";
export const REGISTER_DETAILS_FAIL = "REGISTER_DETAILS_FAIL";
export const REGISTER_DETAILS_RESET = "REGISTER_DETAILS_RESET";

export const REGISTER_UPDATE_PROFILE_REQUEST = "REGISTER_UPDATE_PROFILE_REQUEST";
export const REGISTER_UPDATE_PROFILE_SUCCESS = "REGISTER_UPDATE_PROFILE_SUCCESS";
export const REGISTER_UPDATE_PROFILE_FAIL = "REGISTER_UPDATE_PROFILE_FAIL";
export const REGISTER_UPDATE_PROFILE_RESET = "REGISTER_UPDATE_PROFILE_RESET";